// extracted by mini-css-extract-plugin
export var active = "_9o-7";
export var container = "_9o-0";
export var evenWidth = "_9o-4";
export var large = "_9o-5";
export var outlet = "_9o-8";
export var slide = "_9o-2";
export var small = "_9o-6";
export var tab = "_9o-3";
export var tabs = "_9o-1";